// extracted by mini-css-extract-plugin
module.exports = {"notFoundContainer":"_2o_Ws1ZD7Hhp7C0VyKFOi1","title":"_3w9xjQkxA4HWlytXkjImjD","subTitle":"_3v7MJRoJMYBI9ZrK8d-qAB"};